/**
 * @generated SignedSource<<fb8696bf32bf98f112997aaa27663d06>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueNavigatorUI_jiraView$data = {
  readonly __typename: string;
  readonly error: {
    readonly extensions: ReadonlyArray<{
      readonly statusCode: number | null | undefined;
    }> | null | undefined;
    readonly message: string | null | undefined;
  } | null | undefined;
  readonly savedViewId?: string | null | undefined;
  readonly viewSettings?: {
    readonly canEnableGrouping: boolean | null | undefined;
    readonly isGroupingEnabled: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_FullPageIssueApp_view" | "main_issueNavigator_Header_jiraViewResult" | "main_issueNavigator_IssueResults_jiraView" | "topBar_issueNavigator_jiraViewResult">;
  readonly " $fragmentType": "main_issueNavigator_IssueNavigatorUI_jiraView";
};
export type main_issueNavigator_IssueNavigatorUI_jiraView$key = {
  readonly " $data"?: main_issueNavigator_IssueNavigatorUI_jiraView$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueNavigatorUI_jiraView">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "savedViewId"
      }
    ]
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "groupBy"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "kind": "RootArgument",
      "name": "settings"
    },
    {
      "kind": "RootArgument",
      "name": "staticViewInput"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueNavigatorUI_jiraView",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "concreteType": "QueryError",
      "kind": "LinkedField",
      "name": "error",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "extensions",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "statusCode"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "message"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_Header_jiraViewResult"
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_IssueResults_jiraView"
    },
    {
      "kind": "FragmentSpread",
      "name": "topBar_issueNavigator_jiraViewResult"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "main_issueNavigator_FullPageIssueApp_view"
        }
      ],
      "type": "JiraIssueSearchViewMetadata",
      "abstractKey": "__isJiraIssueSearchViewMetadata"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "groupBy",
              "variableName": "groupBy"
            },
            {
              "kind": "Variable",
              "name": "issueSearchInput",
              "variableName": "issueSearchInput"
            },
            {
              "kind": "Variable",
              "name": "settings",
              "variableName": "settings"
            },
            {
              "kind": "Variable",
              "name": "staticViewInput",
              "variableName": "staticViewInput"
            }
          ],
          "concreteType": "JiraIssueSearchViewConfigSettings",
          "kind": "LinkedField",
          "name": "viewSettings",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isGroupingEnabled"
            },
            {
              "kind": "ScalarField",
              "name": "canEnableGrouping"
            }
          ]
        }
      ],
      "type": "JiraSpreadsheetView",
      "abstractKey": "__isJiraSpreadsheetView"
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "JiraDetailedView"
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "JiraGroupedListView"
    },
    {
      "kind": "InlineFragment",
      "selections": (v0/*: any*/),
      "type": "JiraListView"
    }
  ],
  "type": "JiraView",
  "abstractKey": "__isJiraView"
};
})();

(node as any).hash = "8c632d89d59af9b69a577fb02f589e93";

export default node;
